module.exports = __webpack_public_path__ + "login.9629c460.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/data/images/login.jpg
// module id = kQpO
// module chunks = 0